export default __webpack_public_path__ + "static/media/img (3).96ead0d7.jpg";